module.exports = __webpack_public_path__ + "static/media/K2.3563b865.jpg";